import {
  Autocomplete,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { DataService } from "../../services/DataService";
import { _ROUTES } from "../../utils/_routes_constants";
import { _ACTIONS, _HTTP, _MEMBER, _MESSAGES } from "../../utils/constants";
import { buildOptionsAutoSelect } from "../../utils/formHelper";
import { createToast } from "../../utils/toast";

/**
 * Component to save the link beetwen activity and theme and account parameter in the DB
 * @param {*} param0
 * @returns
 */
export const BaseBudgetSave = ({
  arrayData, // array of objects with activity and theme at /src/utils/constantsSave.js
  category, // category name at /src/utils/constantsSave.js to save the data
}) => {
  const [accountParameters, setAccountParameters] = useState([]);
  const [listLoaded, setListLoaded] = useState(false);
  const [listActivity, setListActivity] = useState([]);
  const [listAP, setListAP] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const dataService = new DataService();

  const actions = (data) => {
    if (data.length > 0) {
      const listAccountP = buildOptionsAutoSelect(data, "name", "@id");
      setAccountParameters(listAccountP);
    }
  };

  const actionsActivity = (data) => {
    if (data.length > 0) {
      let arrayDataActivity = [];
      data.map((item) => (arrayDataActivity[item.code] = item["@id"]));

      setListActivity(arrayDataActivity);
    }
  };

  const actionsAccountParameter = (data) => {
    if (data.length > 0) {
      let arrayAP = [];

      data.forEach((item) => {
        const activityCode = item.activity.code;
        const themeName = item.theme;

        // Initialiser la structure si elle n'existe pas encore
        if (!arrayAP[activityCode]) {
          arrayAP[activityCode] = {};
        }

        // Ajouter les données pour ce thème
        arrayAP[activityCode][themeName] = {
          id: item["@id"],
          accountParameter1: item?.accountParameter?.["@id"] || null,
          accountParameter2: item?.accountParameter_2?.["@id"] || null,
        };
      });
      setListAP(arrayAP);
    }
  };

  /* Return Account Parameter Select Value if exist in DB */
  const getDataValue = (activity, theme, index) => {
    // Vérifier si les niveaux du tableau existent
    if (listAP[activity] && listAP[activity][theme]) {
      if (index === 0) {
        // Obtenir la clé à l'index demandé
        const keyAtIndex = listAP[activity][theme]["accountParameter1"];
        if (keyAtIndex) {
          // Trouver l'option correspondante dans accountParameters
          return accountParameters.find((element) => element.id === keyAtIndex);
        }
      }
      if (index === 1 && listAP[activity][theme]["accountParameter2"]) {
        // Trouver l'option correspondante dans accountParameters
        const keyAtIndex = listAP[activity][theme]["accountParameter2"];
        if (keyAtIndex) {
          return accountParameters.find((element) => element.id === keyAtIndex);
        }
      }
    }

    return null;
  };

  // // Check if the data already exist in DB and change the method and URL
  const getLinkByActivytyTheme = (activity, theme) => {
    if (
      listAP[activity] &&
      listAP[activity][theme] &&
      listAP[activity][theme]["id"]
    ) {
      return listAP[activity][theme]["id"];
    }
    return null;
  };

  useEffect(() => {
    if (!listLoaded) {
      // get account parameters for the select
      console.log("Loading account parameters and activities...");
      dataService
        .doRequest(_ACTIONS.GET, _ROUTES.ACCOUNT_PARAMETERS, {
          "groups[]": ["select:get"],
          pagination: false,
          active: 1,
          grouping: 0,
        })
        .then((response) => actions(response[_MEMBER]));
      // get activities to save the data
      dataService
        .doRequest(_ACTIONS.GET, _ROUTES.ACTIVITIES, {
          "groups[]": ["select:get"],
          pagination: false,
          active: 1,
          grouping: 0,
        })
        .then((response) => actionsActivity(response[_MEMBER]));
      // get data to load and put in the table
      dataService
        .doRequest(_ACTIONS.GET, _ROUTES.BUDGET_SAVE, { category: category , pagination: false})
        .then((response) => actionsAccountParameter(response[_MEMBER]));
      // End of the loading
      setListLoaded(true);
    }
  }, [listLoaded]);

  /** Reload AP for updated Select */
  useEffect(() => {
    dataService
      .doRequest(_ACTIONS.GET, _ROUTES.BUDGET_SAVE, { category: category, pagination: false })
      .then((response) => actionsAccountParameter(response[_MEMBER]));
  }, [refresh]);

  /** Save choices in DB */
  const handleChangeValue = (value, activity, theme, index) => {
    if (value === null) return;
    const themeName = theme.includes("#")
      ? theme.substring(0, theme.indexOf("#")).trim()
      : theme;
    let param = {
      activity: listActivity[activity],
      theme: themeName,
      category: category,
    };
    // If Account parameter #2 is handled we need to add it to the param

    if (index === 0) {
      param["accountParameter"] = value["id"];
    } else {
      param["accountParameter_2"] = value["id"];
    }

    // Check if the data already exist in DB and change the method and URL
    const method = getLinkByActivytyTheme(activity, themeName)
      ? _ACTIONS.PATCH
      : _ACTIONS.POST;
    const url =
      method === _ACTIONS.PATCH
        ? listAP[activity][themeName]["id"]
        : _ROUTES.BUDGET_SAVE;

    // do request to save the data
    dataService
      .doRequest(method, url, param)
      .then((response) => {
        if (response.status === _HTTP.ok) {
          createToast("success", _MESSAGES.data_sent);
        }
      })
      .catch((error) => {
        createToast("error", "Error saving data" + error.message);
      });
    setRefresh(!refresh);
  };

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="fleet optimization table">
          <TableHead>
            <TableRow>
              <TableCell>Activity</TableCell>
              <TableCell>Theme</TableCell>
              <TableCell align="right">Account Parameter</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {arrayData.map((item) =>
              item.theme.map((theme, themeIndex) => (
                <TableRow
                  size="small"
                  key={`${item.activity}-${themeIndex}`}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  {themeIndex === 0 && (
                    <TableCell
                      rowSpan={item.theme.length}
                      component="th"
                      scope="row"
                    >
                      {item.activity}
                    </TableCell>
                  )}
                  <TableCell>{theme.name}</TableCell>
                  <TableCell align="right">
                    <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                      {Array.from({ length: theme.quantity }, (_, index) => (
                        <Autocomplete
                          key={`autocomplete-${item.activity}-${theme.name}-${index}`}
                          value={getDataValue(item.activity, theme.name, index)}
                          freeSolo
                          size="small"
                          dt-activity={item.activity}
                          dt-theme={theme.name}
                          dt-index={index}
                          id={`account-parameter-${item.activity}-${theme.name}-${index}`}
                          options={accountParameters}
                          getOptionLabel={(option) => option?.label || ""}
                          style={{ width: 300, marginBottom: 8 }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={`Account Parameter ${index + 1}`}
                            />
                          )}
                          onChange={(event, value) => {
                            handleChangeValue(
                              value,
                              item.activity,
                              `${theme.name} #${index + 1}`,
                              index,
                            );
                          }}
                        />
                      ))}
                    </Box>
                  </TableCell>
                </TableRow>
              )),
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
